import { render, staticRenderFns } from "./CardProductQuantity.vue?vue&type=template&id=280268c0&"
import script from "./CardProductQuantity.vue?vue&type=script&lang=js&"
export * from "./CardProductQuantity.vue?vue&type=script&lang=js&"
import style0 from "./CardProductQuantity.vue?vue&type=style&index=0&id=280268c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
